export const reflectionLyrics = [
  { text: "Hooo", start: 9, end: 11 },
  { text: "Oooo", start: 11, end: 13 },
  { text: "Hoooo", start: 13, end: 14.5 },
  { text: "Oooo", start: 14.5, end: 16 },
  { text: "Knowing that I gave my all", start: 16, end: 19.95 },
  { text: "Allows me to embrace the fall", start: 19.95, end: 23.8 },
  { text: "Even though it's not you who catches me", start: 23.8, end: 29.8 },
  { text: "Haaa ahhh ahh", start: 29.8, end: 32.5 },
  { text: "Suddenly I over stand", start: 32.5, end: 36.5 },
  { text: "We were burning at both ends", start: 36.5, end: 40.6 },
  { text: "But there's a version of you that keeps", start: 40.6, end: 44 },
  { text: "Haunting me", start: 44, end: 46 },
  { text: "Oh me, oh my", start: 46, end: 49.2 },
  { text: "I found peace in despair", start: 49.2, end: 52.29 },
  { text: "You were my pain to bear", start: 52.29, end: 55 },
  { text: "Yes", start: 55, end: 57 },
  { text: "I admit that I loved in vain", start: 57, end: 61.7 },
  { text: "Forgive and forget", start: 61.7, end: 70.38 },
  { text: "Every memory", start: 70.38, end: 73.5 },
  { text: "That takes", start: 73.5, end: 75.9 },
  { text: "The present one away", start: 75.9, end: 77 },
  { text: "But by letting go", start: 77, end: 79.8 },
  { text: "I have control of my reflection of love", start: 79.8, end: 89.57  },
  { text: "Iiiiiiiii", start: 89.57, end: 96.9 },
  { text: "All that I am", start: 96.8, end: 99.4 },
  { text: "All that I am", start: 99.4, end: 100.7 },
  { text: "Is all because you weren't", start: 100.7, end: 103.5 },
  { text: "What good is devotion", start: 103.5, end: 107.48 },
  { text: "If I have to lose me for it", start: 107.48, end: 112.33 },
  { text: "You can't give me things", start: 112.33, end: 116.59 },
  { text: "You don't possess", start: 116.59, end: 120.36 },
  { text: "The more that I beg you", start: 120.36, end: 123.8 },
  { text: "You love me less", start: 123.8, end: 128.79 },
  { text: "Oh what a rocky road", start: 128.79, end: 131 },
  { text: "That I have trekked", start: 131, end: 135.23 },
  { text: "Selfishly paving", start: 135.23, end: 139.68 },
  { text: "All my missteps, Mama say don't you", start: 139.68, end: 144.5 },
  { text: "Don't cry on soldiers", start: 144.5, end: 149 },
  { text: "That just can't hold ya", start: 149, end: 151.33 },
  { text: "They'll turn you sour", start: 151.33, end: 155 },
  { text: "Steal all your power baby", start: 155, end: 159.8 },
  { text: "Don't cry on shoulders", start: 159.8, end: 163.9 },
  { text: "They'll turn you sour, they can", start: 163.9, end: 167.9 },
  { text: "Steal all your power", start: 167.9, end: 171  },
  { text: "Don't cry on shoulders my darlin don't cry", start: 171, end: 177.46 },
  { text: "Mmmmmmmmmmm", start: 177.46, end: 181 },
  { text: "Mmmmmm mmmm mmmm", start: 181, end: 185.5 },
  { text: "Mmmmmmmmm", start: 185.5, end: 188 },
  { text: "Mmm", start: 188, end: 189 },
  { text: "Mm mm mm mm mm mm mm mm mm mm mm mm", start: 189, end: 197 },
  { text: "For", start: 204.8, end: 206 },
  { text: "For", start: 206, end: 207 },
  { text: "For", start: 207, end: 208 },
  { text: "Forgive and forget", start: 208, end: 213.6 },
  { text: "Every memory that takes", start: 213.6, end: 218 },
  { text: "The present one away", start: 218, end: 221 },
  { text: "But by letting go", start: 221, end: 225.2 },
  { text: "I have control of my reflection of love", start: 225.5, end: 235.4 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
